// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__USRYl","label":"styles_label__3xlhP"};